import YoojoDirectCover from "../../../assets/images/yoojo-direct.svg";
import { spacings } from "../../../assets/themes";
import { Block, List } from "../../../components";
import { useGetYoojoDirectJobs } from "../../../modules/routes/dashboard-routes";
import polyglot from "../../../utils/polyglot";
import JobsSkeleton from "../skeletons/JobsSkeleton";
import JobsItem from "./JobsItem";

const YoojoDirectJobs = () => {
  const { isLoading, data } = useGetYoojoDirectJobs();
  return (
    <>
      {!isLoading && data ? (
        <>
          <Block marginY={spacings.s}>
            <List.Header>
              {polyglot.t("common.enabled", {
                count: data.direct_relations_active.length,
              })}
            </List.Header>
            {data.direct_relations_active?.length > 0 &&
              data.direct_relations_active.map((relation) => (
                <JobsItem
                  key={`job-${relation.id}`}
                  title={relation.title}
                  url={relation.url}
                  cover={YoojoDirectCover}
                  subtitle={`${relation.frequency} • ${relation.nb_hours}`}
                />
              ))}
          </Block>
          <Block marginY={spacings.s}>
            {data.direct_relations_inactive.length > 0 && (
              <List.Header>{polyglot.t("common.closed_f")}</List.Header>
            )}
            {data.direct_relations_inactive.map((relation) => (
              <JobsItem
                key={`job-${relation.id}`}
                title={relation.title}
                url={relation.url}
                cover={YoojoDirectCover}
                subtitle={`${relation.frequency} • ${relation.nb_hours}`}
              />
            ))}
          </Block>
        </>
      ) : (
        <JobsSkeleton />
      )}
    </>
  );
};

export default YoojoDirectJobs;
